export default {
    props:{
        uriGetFarmer: {
            type: String,
            default: ''
        },
        uriGetCreditInfo: {
            type: String,
            default: ''
        },
        uriGetField: {
            type: String,
            default: ''
        },
    },
    data: function() {
        return {
            form: {
                admin_user_id:  '' ,
                app_offices_id:  '' ,
                app_factories_id:  '' ,
                app_parent_factories_id:  '' ,
                app_farmer_drivers_id:  '' ,
                driver_name:  '' ,
                farmer_name:  '' ,
                factory_ticket_number:  '' ,
                weighing_date:  '' ,
                bruto:  0 ,
                tara:  0 ,
                netto_first:  0 ,
                potongan:  0 ,
                netto:  0 ,
                app_prices_factory_id:  '' ,
                app_fields_id:  '' ,
                price:  0 ,
                price_extra:  0 ,
                price_extra_other:  0 ,
                price_driver_extra:  0 ,
                calculated_by:  'netto' ,
                farmer_total_payment: 0 ,
                driver_price:  0 ,
                sopoi_price:  0 ,
                operational_price:  0 ,
                driver_total_payment:  0 ,
                total_payment:  0 ,
                farmer_print:  false ,
                driver_print:  false ,
                split_payment:  false ,
                app_factory_transaction_id:  '' ,
                data: {
                    notes: null,
                    force_update_reason:null,
                    manual_amprah:0,
                },
                action_group: 'no_group', // ['group', 'no_group', 'new_group']
                group_payments_id: null,
                source_balance_id: null
                
            },
            tempFarmerDriver: null,
            tempFactory: "",
            tempField: "",
            tempPriceFactory: "",
            useNote: false,
            togglePratinjau: false,
            listFarmer: [],
            submittingGetListFarmer: false,
            listField: [],
            submittingGetListField: false,
            messageCreditInfo: [],

            groupPayments:[],
            showHistories: {
                type: Boolean,
                default: false
            },
        }
    },
    methods:{
        showDetailCredit(appFarmerDriver) {
            
            const _thisLocal = this
            _thisLocal.submittingGetListField = true
            axios.get(`${this.uriGetCreditInfo}?app_farmer_drivers_id=${appFarmerDriver.id}`).then(function (response) {
                _thisLocal.submittingGetListField = false
                _thisLocal.$notify({
                    type: 'sucess',
                    title: 'Success',
                    text: response.data.message,
                    position:"top center"
                  });
                  
                  _thisLocal.messageCreditInfo = response.data.data.data
            }).catch(function (errors) {
                  _thisLocal.submittingGetListField = false
                return _thisLocal.onFail(errors.response.data);
              });
        },
        onUpdateFarmerDriver(appFarmerDriver) {
            this.messageCreditInfo = []
            if (appFarmerDriver !== null) {
                this.form.app_farmer_drivers_id = appFarmerDriver.id;
                this.form.driver_name = appFarmerDriver.driver_name;
                this.form.farmer_name = appFarmerDriver.farmer_name;
                this.showDetailCredit(appFarmerDriver)
            }else{
                this.form.app_farmer_drivers_id = "";
                this.form.driver_name = "";
                this.form.farmer_name = "";
            }
        },
        onRemoveFarmerDriver(appFarmerDriver) {
            console.log('onRemoveFarmerDriver')
            console.log(appFarmerDriver)
            this.form.app_farmer_drivers_id = "";
            this.form.driver_name = "";
            this.form.farmer_name = "";
        },
        onUpdateFactory(appFactory) {
            console.log('onUpdateFactory appFactory', appFactory)
            const data_json = this.form.data ||{}
            data_json.orientation = 0
            if (appFactory !== null) {
                data_json.orientation = appFactory.print_orientation
                this.form.data = data_json;

                this.form.app_factories_id = appFactory.id;
            }else{
                this.form.app_factories_id = "";
            }
        },
        onRemoveFactory(appFactory) {
            this.form.app_factories_id = "";
        },
        onUpdateField(appField) {
            if (appField !== null) {
                this.form.app_fields_id = appField.id;
            }else{
                this.form.app_fields_id = "";
            }
        },
        onRemovePriceFactory(appPriceFactory) {
            this.form.app_prices_factory_id = "";
        },
        onUpdatePriceFactory(appPriceFactory) {
            console.log('appPriceFactory', appPriceFactory)
            if (appPriceFactory !== null) {
                this.form.app_prices_factory_id = appPriceFactory.id;
                this.form.price = appPriceFactory.price;
            }else{
                this.form.app_prices_factory_id = "";
                this.form.price = 0;
            }
        },
        onRemovePriceFactory(appPriceFactory) {
            this.form.app_prices_factory_id = "";
            this.form.price = 0;
        },
        onUpdateField(appField) {
            if (appField !== null) {
                this.form.app_fields_id = appField.id;
            }else{
                this.form.app_fields_id = "";
            }
        },
        onRemoveField(appField) {
            this.form.app_fields_id = "";
        },
        useNotesAction() {
            // this.form.app_fields_id = "";
            this.useNote= !this.useNote
        },
        getNettoFirst(){
            this.form.netto_first = this.form.bruto - this.form.tara 
            return this.form.netto_first
        },
        getListFarmer(){

            if (this.tempFarmerDriver.hasOwnProperty('id')) {
                this.optionSearchDriverFarmer = [this.tempFarmerDriver]
            }
            /* 
            const _thisLocal = this
            _thisLocal.submittingGetListFarmer = true
            axios.get(`${this.uriGetFarmer}?isGetListFarmerDriver=true`).then(function (response) {
                _thisLocal.listFarmer = response.data.data
                _thisLocal.submittingGetListFarmer = false
                _thisLocal.$notify({
                    type: 'sucess',
                    title: 'Success',
                    text: response.data.message,
                    position:"top center"
                  });
            }).catch(function (errors) {
                  _thisLocal.submittingGetListFarmer = false
                return _thisLocal.onFail(errors.response.data);
            }); 
            */
        },
        getListFields(){
            const _thisLocal = this
            _thisLocal.submittingGetListField = true
            axios.get(`${this.uriGetField}?isGetListFields=true`).then(function (response) {
                _thisLocal.listField = response.data.data
                _thisLocal.submittingGetListField = false
                _thisLocal.$notify({
                    type: 'sucess',
                    title: 'Success',
                    text: response.data.message,
                    position:"top center"
                  });
            }).catch(function (errors) {
                  _thisLocal.submittingGetListField = false
                return _thisLocal.onFail(errors.response.data);
              });
        },
        actionGetList(submitting, uri, listPlace) {
            const _thisLocal = this
            submitting = true
            axios.get(`${uri}`).then(function (response) {
                listPlace = response.data.data
                submitting = false
                _thisLocal.$notify({
                    type: 'sucess',
                    title: 'Success',
                    text: response.data.message,
                    position:"top center"
                  });
            }).catch(function (errors) {
                  submitting = false
                return _thisLocal.onFail(errors.response.data);
            });
        }, 
        loadLog(index){
            const log = this.logs[index]
            for (const key in log.value) {
                if (Object.hasOwnProperty.call(log.value, key)) {
                    const element = log.value[key];
                    if (key == 'data') {
                    }else{
                        // console.log('key ', key, ' value ', element)
                        if (this.form.hasOwnProperty(key)) {
                            this.form[key] = element
                        }else if(this.form.data.hasOwnProperty(key)){
                            this.form.data[key] = element
                        }
                    }
                }
            }
        }
    },
    mounted: function () {  
        this.tempFarmerDriver = this.selectedFarmerDriver
        this.tempFactory = this.selectedFactory
        this.tempField = this.selectedField
        this.tempPriceFactory = this.selectedPriceFactory
        this.form.weighing_date = this.getDateFromString(this.form.weighing_date, null, new Date())
        if (this.form.group_payments_id) {
            this.form.action_group = 'group'
            // this.groupPayments = 'group'
        }
    },
    computed: {
        hasNotes(){
            return !(this.form.data?.notes==null || this.form.data?.notes=='')
        },
        getCalculatedVehicleFactorValue(){
            // return (this.form.calculated_by == 'bruto') ? this.form.bruto : this.form.netto
            // return (this.form.calculated_by == 'bruto') ? this.getNettoFirst() : this.form.netto
            let result = 0;
            switch (this.form.calculated_by) {
                case 'bruto':
                    result = this.getNettoFirst()
                    break;
            
                case 'manual':
                    result = this.form.data.manual_amprah
                    break;
            
                default:
                    result = this.form.netto
                    break;
            }
            return result
        },
        getNetto () {
            // let netto = this.form.bruto - this.form.tara - this.form.potongan
            let netto = this.getNettoFirst() - this.form.potongan
            if (netto<=0) {
               netto = 0 
            }
            this.form.netto = netto
          return netto
        },
        getTotalPayment () {
            // const calculatedFactorvalue = this.getCalculatedVehicleFactorValue
            let total_payment = this.form.netto* this.form.price
            // let total_payment = calculatedFactorvalue* this.form.price
            if (total_payment<=0) {
               total_payment = 0 
            }
            this.form.total_payment = total_payment
          return total_payment
        },
        getDriverTotalPayment () {
            const calculatedFactorvalue = this.getCalculatedVehicleFactorValue
            // let driver_payment = this.form.netto* this.form.driver_price
            let driver_payment = calculatedFactorvalue* this.form.driver_price
            if (driver_payment<=0) {
               driver_payment = 0 
            }
            this.form.driver_payment = driver_payment

            let driver_total_payment = parseInt(driver_payment) + parseInt(this.form.operational_price) + parseInt(this.form.sopoi_price)
            this.form.driver_total_payment = driver_total_payment

            this.form.farmer_total_payment = this.form.total_payment - driver_total_payment
             
          return driver_total_payment
        },
        getTotalExtra(){
            return this.form.price_extra*this.form.netto
        },
        getTotalExtraOther(){
            return this.form.price_extra_other*this.form.netto
        },
        getTotalExtraAmprah(){
            return this.form.price_driver_extra*this.form.netto
        }
    }

}